module.exports = __webpack_public_path__ + "static/assembly-5057aa32680e5acbf134374de2c5ce02.jpeg";